import { COLOR } from '@/shared/constant/color'
import { ModalBtn } from '@/styles/common/CommonForm/buttonform'
import { ModalAlertContent, ModalOnlyTitle } from '@/styles/common/modal'

const AlertModal = (props: any) => {
  const { option, ClickFunc } = props
  return (
    <ModalAlertContent>
      <ModalOnlyTitle>{option}</ModalOnlyTitle>
      <ModalBtn bgColor={COLOR.point1} onClick={ClickFunc}>
        <span>확인</span>
      </ModalBtn>
    </ModalAlertContent>
  )
}
export default AlertModal
